import { v4 as uuidv4 } from 'uuid'

export const clientConcentrationRiskTestData = {
  title: 'Client Concentration Risk',
  item: '22.3%',
  key: uuidv4()
}
